import { render, staticRenderFns } from "./WorkingSR.vue?vue&type=template&id=90da7596&scoped=true"
import script from "./WorkingSR.vue?vue&type=script&lang=js"
export * from "./WorkingSR.vue?vue&type=script&lang=js"
import style0 from "./WorkingSR.vue?vue&type=style&index=0&id=90da7596&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da7596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90da7596')) {
      api.createRecord('90da7596', component.options)
    } else {
      api.reload('90da7596', component.options)
    }
    module.hot.accept("./WorkingSR.vue?vue&type=template&id=90da7596&scoped=true", function () {
      api.rerender('90da7596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingSR.vue"
export default component.exports